import { render, staticRenderFns } from "./CwcButton.vue?vue&type=template&id=23c37e2a"
import script from "./CwcButton.vue?vue&type=script&lang=js"
export * from "./CwcButton.vue?vue&type=script&lang=js"
import style0 from "./CwcButton.vue?vue&type=style&index=0&id=23c37e2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports